
import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
//@ts-ignore
import { saveAs } from 'file-saver';
import * as ExcelJS from "exceljs";
import { Chart } from 'highcharts';
import { Workbook, Worksheet } from 'exceljs';

export class UtilidadExportXLSX {

	public medidas = [['yyyy/mm/dd']];

	public exportarXLSX(c: any) {
		//console.log('UtilidadExportXLSX:chart', c);
		let DEFAULT_COL_WIDTH: number = 19.43 + 0.71;
		// Array of chart data rows with header row removed
		var dataRows = c.getDataRows().slice(1);
		let listaSeries = c.userOptions.series!;
		const workbook = new ExcelJS.Workbook();
		let worksheetDatos = workbook.addWorksheet('Datos');
		let worksheetInformacion: Worksheet = workbook.addWorksheet('Información');
		worksheetInformacion = this.getHojaInformacion(worksheetInformacion, listaSeries);

		// Array with column header titles as they will appear when exported
		let columnHeaders = [];
		// Array that will contain exceljs column objects
		let worksheetColumns: any[] = [];

		// Add chart category column to worksheet columns array
		let categoryColumnOptions = {}

		var xlsxOptions = c.options.exporting.csv;
		//console.log('xlsxOptions', xlsxOptions);
		//var worksheetName = c.pick(xlsxOptions.worksheet.sheetName.substring(0, 31), 'Sheet1');
		//console.log('worksheetName',worksheetName);
		let fmt = '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';
		// Add each chart series to the worksheet columns array
		worksheetColumns.push({header:'Fecha', key:'fecha', width: DEFAULT_COL_WIDTH});
		c.series.forEach((serie:any) => {
			if(!serie.name.includes("Navigator") && serie.visible){
				var seriesOptions = serie.options;
				//console.log('seriesOptions', seriesOptions);
				var seriesColumnOptions: any = {};
				// Use user-specified column header or default series name
				var seriesColumnHeader = serie.name;
				columnHeaders.push(seriesColumnHeader);
				seriesColumnOptions.header = seriesColumnHeader;
				seriesColumnOptions.key = seriesColumnHeader;

				seriesColumnOptions.width = DEFAULT_COL_WIDTH;
				seriesColumnOptions.z  = fmt;
				seriesColumnOptions.numeroDecimales = seriesOptions.numeroDecimales;
				let numFmt = '';
				let numFmt2 = '';
				for (let i=0; i<seriesOptions.numeroDecimales; i++) {
					numFmt += '#';
					numFmt2 += '0';
				}
				seriesColumnOptions.numFmt = '#,' + numFmt + '0.' + numFmt2;
				/*if (seriesOptions.xlsx.numberFormat) {
					seriesColumnOptions.style = { numFmt: seriesOptions.xlsx.numberFormat }; //validar
					seriesColumnOptions.width = DEFAULT_COL_WIDTH;
				}*/
				worksheetColumns.push(seriesColumnOptions);
			}
		});

		//console.log('worksheetColumns', worksheetColumns);
		// Add all columns to the worksheet object
		worksheetDatos.columns = worksheetColumns;
		// Set date values in category column for correct Excel export if chart
		// has
		// a datetime axis
		for (let i=0; i<dataRows.length; i++) {
			if (String(dataRows[i][0]).length > 10)
				dataRows[i][0] = String(dataRows[i][0]).substring(0,10);
				//dataRows[i][1] = this.formatearNumero(dataRows[i][1]);
		}
		if (c.axes[0].isDatetimeAxis) {
			dataRows.forEach(function (value: any, index: number) {
				// Need to add 'Z' to make sure values are in UTC time
				var jsDate = new Date(value[0] + 'Z');
				console.log(typeof jsDate, jsDate);
				dataRows[index][0] = jsDate;
			});
		}

		// Add the data to the worksheet
		worksheetDatos.addRows(this.medidas);
		worksheetDatos.addRows(dataRows);

		for (let j=1; j<worksheetColumns.length; j++) {
			if (worksheetColumns[j].numeroDecimales > 0) {
				for (let i=3; i<dataRows.length+3; i++) {
					worksheetDatos.getCell(i, j+1).numFmt = worksheetColumns[j].numFmt;
				}
			}
		}

		var fecha = new Date();
		var fechaFormateada = fecha.toLocaleDateString("es-CO",
			{
				weekday: 'long', year: 'numeric', month: 'long',
				day: 'numeric'
			}) + ' ' + fecha.toLocaleTimeString("es-CO");
		worksheetDatos.addRows([[''], [''],
		['Descargado de sistema del Banco de la República '
			+ fechaFormateada]]);


		this.generarArchivo(workbook, c.userOptions.exporting.filename);
	}

	/**
	 * Función donde se crea la hoja con lan información de las series
	 * @param worksheetInformacion 
	 * @param series 
	 * @returns Worksheet
	 */
	private getHojaInformacion(worksheetInformacion: any, series: any): Worksheet {
		var colWs2 = [
			{
				header: "Nombre de la serie",
				key: "nombre",
				width: 50
			},
			{
				header: "Unidad de medida",
				key: "unidad",
				width: 25
			},
			{
				header: "Periodicidad",
				key: "periodicidad",
				width: 20
			},
			{
				header: "Fuente",
				key: "fuente",
				width: 40
			},
			{
				header: "Notas",
				key: "notas",
				width: 50
			}
		];
		worksheetInformacion.columns = colWs2;
		let info: any[] = [];
		series.forEach((serie: any) => {
			info.push([serie.name, serie.unidadCorta, serie.periodicidadNombre, serie.fuente, serie.notas]);
			this.medidas[0].push(serie.unidadCorta);
		});
		worksheetInformacion.addRows(info);
		worksheetInformacion.eachRow((row: any, columnNumber: any) => {
			row.eachCell((cell: any, rowNumber: any) => {
				if (columnNumber !== 1) {
					cell.alignment = {
						vertical: 'middle',
						wrapText: true
					};
				} else {
					cell.font = {
						bold: true
					};
					cell.alignment = {
						horizontal: 'center'
					}
				}
			});
		});
		return worksheetInformacion;
	}

	public generarArchivo(workbook: Workbook, filename: string) {
		// Crea un objeto Blob y guarda el archivo Excel
		workbook.xlsx.writeBuffer().then(buffer => {
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			saveAs.saveAs(blob, filename + '.xlsx');
		});
	}

	public downloadBalanzaPagosXLSX() {

	}
}